export enum TableChartState {
    TABLE,
    CHART
}
